export default __webpack_public_path__ + "static/media/A4HLOGO.ca25c7fe.png";